export const LABEL_ALIGN_TYPE = {
  left: 'left',
  right: 'right',
}

export const FORM_ITEM_VALIDATE_STATUS = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  validating: 'validating',
}

export const FORM_SELECT_MODE_PROPS = {
  multiple: 'multiple',
  tags: 'tags',
}

export const DATE_FORMAT_LIST = [
  'MM-DD-YYYY',
  'MM/DD/YYYY',
  'MM/DD/YY',
  'MM-DD-YY',
  'M-D-YY',
  'M/D/YY',
  'M/D/YYYY',
  'M-D-YYYY',
]
export const DATE_TIME_FORMAT = 'MM-DD-YYYY, HH:mm'
export const TABLE_DATE_FORMAT = 'MMM DD, YYYY'
export const DISPLAY_DATE_FORMAT = 'MMM DD YYYY'

export const DEFAULT_INPUT_LENGTH = 51
export const INPUT_DATE_PICKER_TYPE = 'date'

export const sampleLocationDropdownOptions = [
  { name: 'Seattle', value: 'seattle' },
  { name: 'Texas', value: 'texas' },
]

export const sampleRolenDropdownOptions = [
  { name: 'Registered Nurse', value: 'registered-nurse' },
  { name: 'Software Developer', value: 'software-developer' },
]

export const sampleLanguageDropdownOptions = [
  { name: 'English', value: 'english' },
  { name: 'French', value: 'french' },
]

export const sampleGenderDropdownOptions = [
  { name: 'Male', value: 'male' },
  { name: 'Female', value: 'female' },
  { name: 'Others', value: 'others' },
]

export const sampleReasonForReferralDropdownOptions = [
  { name: 'Unexpected outcome or event', value: 'Unexpected-outcome' },
  { name: 'Personal stressors', value: 'personal-stressors' },
  { name: 'Work stressors', value: 'workstressors' },
  { name: 'Other', value: 'other' },
]

export const sampleAvailabilityPreferencesDropdownOptions = [
  { name: 'Teams', value: 'teams' },
  { name: 'Phone', value: 'phone' },
  { name: 'In person', value: 'in-person' },
  { name: 'Text', value: 'text' },
  { name: 'Email', value: 'email' },
]
